export const whitelistExceptions = [
  'currentUser',
  'unit',
  'units',
  'secrets',
]
